export const COLORS = {
  primary: '#144CB8',
  white: '#FFFFFF',
  black: '#0E0E0E',
  darkest: '#080808',
  darkSection: '#1A1A1A',
  lightGray: '#F4F7FE',
  darkGray: '#3E3E3E',
  mediumGray: '#C4D0E6',
  orange: '#FF7B00',
  gradientStart: '#F8F9FD',
  gradientEnd: '#F5F7FF',
  gradientButtonStart: '#538AF9',
  gradientButtonEnd: '#2466ED',
  borderColor: '#E1E7F2',
  shadowColor: 'rgba(0, 0, 0, 0.08)',
  textPrimary: '#0E0E0E',
  textSecondary: 'rgba(14, 14, 14, 0.8)',
  textTertiary: 'rgba(14, 14, 14, 0.5)',
  iconColor: '#2156BB',
  lightBlue: 'rgba(20, 76, 184, 0.1)',
};

export const REDESIGN_COLORS = {
  // Backgrounds & gradients
  backgroundGradientMobile: 'linear-gradient(180deg, #0E264D 0%, #041635 10.1%, #020D25 29.4%, #040409 100%)',
  backgroundGradientDesktop: 'linear-gradient(180deg, #000D26 0%, #040409 100%)',
  cardBg: '#1D242F',
  bottomBar: '#04060F',
  carSelectionFadeColor: '#080A0C',

  // CTAs & badges
  ctaBlue: '#0556F7',
  badgeNewOrange: '#FF7B00',
  badgeSoldRed: '#FF0000',

  // Score tiers
  scoreGood: '#3AE869',
  scoreGoodBg: 'rgba(58,232,105,0.2)',
  scoreMedium: '#FF7B00',
  scoreMediumBg: 'rgba(255,123,0,0.2)',
  scorePoor: '#FF0000',
  scorePoorBg: 'rgba(255,0,0,0.2)',

  // Borders
  borderSubtle: 'rgba(255,255,255,0.16)',
  filterPillBorderInactive: 'rgba(255,255,255,0.2)',
  filterPillBorderActive: 'rgba(255,255,255,1.0)',
  cardSelectedBorder: 'rgba(255,255,255,0.5)',

  // Overlays
  buttonOverlayBg: 'rgba(0,0,0,0.5)',
  photoCounterBg: 'rgba(0,0,0,0.7)',

  // Text & navigation
  textPrimary: '#FFFFFF',
  textSecondary: 'rgba(255,255,255,0.5)',
  navInactive: 'rgba(255,255,255,0.4)',
};
